import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'ChartLine';
const IconTitle = 'Chart line';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 4.5C4.16421 4.5 4.5 4.83579 4.5 5.25V18H20.25C20.6642 18 21 18.3358 21 18.75C21 19.1642 20.6642 19.5 20.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25C3 4.83579 3.33579 4.5 3.75 4.5ZM15.75 7.5C15.3358 7.5 15 7.16421 15 6.75C15 6.33579 15.3358 6 15.75 6H20.25C20.6642 6 21 6.33579 21 6.75V11.25C21 11.6642 20.6642 12 20.25 12C19.8358 12 19.5 11.6642 19.5 11.25V8.56066L14.0303 14.0303C13.7374 14.3232 13.2626 14.3232 12.9697 14.0303L11.25 12.3107L7.28033 16.2803C6.98744 16.5732 6.51256 16.5732 6.21967 16.2803C5.92678 15.9874 5.92678 15.5126 6.21967 15.2197L10.7197 10.7197C11.0126 10.4268 11.4874 10.4268 11.7803 10.7197L13.5 12.4393L18.4393 7.5H15.75Z" fill="currentColor"/>
  </svg>
`;

const ChartLineIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 4.5C4.16421 4.5 4.5 4.83579 4.5 5.25V18H20.25C20.6642 18 21 18.3358 21 18.75C21 19.1642 20.6642 19.5 20.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25C3 4.83579 3.33579 4.5 3.75 4.5ZM15.75 7.5C15.3358 7.5 15 7.16421 15 6.75C15 6.33579 15.3358 6 15.75 6H20.25C20.6642 6 21 6.33579 21 6.75V11.25C21 11.6642 20.6642 12 20.25 12C19.8358 12 19.5 11.6642 19.5 11.25V8.56066L14.0303 14.0303C13.7374 14.3232 13.2626 14.3232 12.9697 14.0303L11.25 12.3107L7.28033 16.2803C6.98744 16.5732 6.51256 16.5732 6.21967 16.2803C5.92678 15.9874 5.92678 15.5126 6.21967 15.2197L10.7197 10.7197C11.0126 10.4268 11.4874 10.4268 11.7803 10.7197L13.5 12.4393L18.4393 7.5H15.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconTitle,

  IconComponent: ChartLineIcon,
  IconSvg: IconSvg
} as IconType;
